(function() {
  function initTabCarousel(carouselId, autoPlayTime) {
    const carousel = document.getElementById(carouselId);
    if (!carousel) return;
    
    const content = carousel.querySelector('.mt-tab-carousel-content');
    let items = carousel.querySelectorAll('.mt-tab-carousel-item');
    let indicators = carousel.querySelectorAll('.mt-tab-carousel-indicator');
    let dots = carousel.querySelectorAll('.mt-tab-carousel-dot');
    let progressDots = carousel.querySelectorAll('.mt-tab-carousel-progress-dot');
    const prevBtn = carousel.querySelector('.mt-tab-carousel-prev');
    const nextBtn = carousel.querySelector('.mt-tab-carousel-next');
    
    // 依据设备过滤不可见的区块，并同步移除对应 dot/指示器
    (function filterBlocksByDevice(){
      const isMobile = window.innerWidth <= 768;
      Array.from(items).forEach(function(el){
        const showPc = el.dataset.showPc !== 'false';
        const showMobile = el.dataset.showMobile !== 'false';
        const idx = el.dataset.blockIndex;
        const shouldShow = isMobile ? showMobile : showPc;
        if (!shouldShow) {
          if (idx !== undefined) {
            const dot = carousel.querySelector('.mt-tab-carousel-dot[data-block-index="' + idx + '"]');
            if (dot) dot.remove();
            const progressDot = carousel.querySelector('.mt-tab-carousel-progress-dot[data-block-index="' + idx + '"]');
            if (progressDot) progressDot.remove();
            const indicator = carousel.querySelector('.mt-tab-carousel-indicator[data-block-index="' + idx + '"]');
            if (indicator) indicator.remove();
          }
          el.remove();
        }
      });
      items = carousel.querySelectorAll('.mt-tab-carousel-item');
      indicators = carousel.querySelectorAll('.mt-tab-carousel-indicator');
      dots = carousel.querySelectorAll('.mt-tab-carousel-dot');
      progressDots = carousel.querySelectorAll('.mt-tab-carousel-progress-dot');
    })();
    
    // 若没有可显示内容则隐藏整个组件
    if (items.length === 0) {
      carousel.style.display = 'none';
      return;
    }

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let currentY = 0;
    let translateX = 0;
    const maxTranslate = 0; // 最大只能到第0张（0%）
    const minTranslate = -((items.length - 1) * 100); // 最小到最后一张（-(n-1)*100%）
    let pageScrollLocked = false;
    let prevBodyOverflow = '';
    
    // 如果只有一个轮播项，禁用轮播功能
    const isSingleItem = items.length === 1;
    if (isSingleItem) {
      // 隐藏导航按钮
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      
      // 隐藏dot点
      dots.forEach(dot => dot.style.display = 'none');
      
      // 隐藏进度条
      progressDots.forEach(progressDot => progressDot.style.display = 'none');
      
      // 播放视频（如果是视频）
      if (isCurrentSlideVideo()) {
        playCurrentVideo();
      }
      
      return; // 提前返回，不执行后续的轮播逻辑
    }
    
    
    // 更新轮播图位置
    function updateCarousel() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 更新进度dot状态
      updateProgressDots();
    }
    
    // Helper函数：更新进度dot状态
    function updateProgressDots() {
      if (progressDots && progressDots.length > 0) {
        progressDots.forEach((progressDot, index) => {
          if (index === currentIndex) {
            progressDot.classList.add('active');
          } else {
            progressDot.classList.remove('active');
          }
        });
      }
    }
    
    // 自动轮播功能
    let autoPlayTimer = null;
    let resumeAutoPlayTimer = null; // 手动交互后的"恢复自动播放"去抖计时器
    let isVideoPlaying = false;
    let isManualInteraction = false;
    let currentVideoEl = null; // 当前已绑定 ended 的视频元素
    let boundVideoEndHandler = null; // ended 事件处理函数引用
    
    // 视频控制功能
    function playCurrentVideo() {
      const currentItem = items[currentIndex];
      if (!currentItem) return;
      
      const video = currentItem.querySelector('video');
      const iframe = currentItem.querySelector('iframe');
      
      if (video) {
        // 播放本地视频（结束事件在其他位置统一绑定）
        video.play().catch(() => {
          // 忽略播放失败错误
        });
      } else if (iframe) {
        // 对于iframe视频，我们无法直接控制播放，但可以尝试发送播放命令
        try {
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        } catch (e) {
          // 忽略错误
        }
        
        // 设置iframe视频的自动播放定时器
        const videoTime = Math.max(getAutoPlayTime() * 3, 15); // 至少15秒，或者默认时间的3倍
        if (autoPlayTimer) { clearTimeout(autoPlayTimer); autoPlayTimer = null; }
        autoPlayTimer = setTimeout(() => {
          isVideoPlaying = false;
          // iframe视频播放完成后，延迟一段时间再切换
          setTimeout(() => {
            // 直接切换到下一个项目
            if (currentIndex < items.length - 1) {
              currentIndex++;
            } else {
              currentIndex = 0;
            }
            
            // 更新轮播位置
            updateCarouselPosition();
            
            // 如果下一个是视频，直接播放；如果是图片，设置定时器
            if (isCurrentSlideVideo()) {
              // 当前是视频，直接播放
              const currentItem = items[currentIndex];
              if (currentItem) {
                const video = currentItem.querySelector('video');
                const iframe = currentItem.querySelector('iframe');
                
                if (video) {
                  // 本地视频 - 不受轮播时间限制，等待视频播放完成
                  isVideoPlaying = true;
                  attachVideoEndHandler(video);
                  // 播放视频
                  video.play().catch(() => { /* 忽略播放失败错误 */ });
                } else if (iframe) {
                  // iframe视频（YouTube/Vimeo等）- 不受轮播时间限制
                  isVideoPlaying = true;
                  
                  // 对于iframe视频，我们无法直接监听结束事件
                  // 使用一个较长的默认时间，让视频有足够时间播放
                  const videoTime = Math.max(getAutoPlayTime() * 3, 15); // 至少15秒，或者默认时间的3倍
                  if (autoPlayTimer) { clearTimeout(autoPlayTimer); autoPlayTimer = null; }
                  autoPlayTimer = setTimeout(() => {
                    isVideoPlaying = false;
                    // iframe视频播放完成后，延迟一段时间再切换
                    setTimeout(() => {
                      // 直接切换到下一个项目
                      if (currentIndex < items.length - 1) {
                        currentIndex++;
                      } else {
                        currentIndex = 0;
                      }
                      
                      // 更新轮播位置
                      updateCarouselPosition();
                      
                      // 重新开始自动轮播
                      startAutoPlay();
                    }, 1000);
                  }, videoTime * 1000);
                }
              }
            } else {
              // 当前是图片，设置定时器
              const time = getAutoPlayTime();
              if (time > 0) {
                if (autoPlayTimer) { clearTimeout(autoPlayTimer); autoPlayTimer = null; }
                autoPlayTimer = setTimeout(() => {
                  // 检查是否还有下一个轮播项
                  if (currentIndex < items.length - 1) {
                    currentIndex++;
                  } else {
                    // 如果是最后一个，回到第一个
                    currentIndex = 0;
                  }
                  
                  // 更新轮播位置
                  updateCarouselPosition();
                  
                  // 重新开始自动轮播
                  startAutoPlay();
                }, time * 1000);
              }
            }
          }, 1000);
        }, videoTime * 1000);
      }
    }

    // 统一为当前视频绑定 ended 事件，避免重复绑定
    function attachVideoEndHandler(videoEl) {
      if (!videoEl) return;
      if (currentVideoEl && boundVideoEndHandler) {
        currentVideoEl.removeEventListener('ended', boundVideoEndHandler);
      }
      currentVideoEl = videoEl;
      boundVideoEndHandler = function() {
        isVideoPlaying = false;
        // 只有在自动轮播时间大于0时才自动切换到下一张
        const time = getAutoPlayTime();
        if (time > 0) {
          setTimeout(() => { nextSlide(); }, 500);
        }
      };
      videoEl.addEventListener('ended', boundVideoEndHandler);
    }
    
    // 根据自动轮播设置控制视频循环播放
    function controlVideoLoop() {
      const time = getAutoPlayTime();
      items.forEach((item, index) => {
        const video = item.querySelector('video');
        const iframe = item.querySelector('iframe');
        
        if (video) {
          // 当时间为0时，禁用循环播放；当时间大于0时，启用循环播放
          const shouldLoop = time > 0;
          // 强制移除或添加loop属性
          if (time> 0) {
            video.removeAttribute('loop');
            video.loop = false;
          } else {
            video.setAttribute('loop', '');
            video.loop = true;
          }
          
          // 监听视频加载完成事件，确保设置生效
          video.addEventListener('loadedmetadata', function() {
            if (time <= 0) {
              video.removeAttribute('loop');
              video.loop = false;
            } else {
              video.setAttribute('loop', '');
              video.loop = true;
            }
          });
          
        }
        
        if (iframe) {
          // 对于iframe视频，我们需要通过修改src来控制循环播放
          if (time <= 0) {
            // 时间为0时，移除循环播放参数
            if (iframe.src.includes('youtube.com')) {
              // YouTube视频
              const videoId = iframe.src.match(/embed\/([^?]+)/)?.[1];
              if (videoId) {
                const newSrc = `https://www.youtube.com/embed/${videoId}?mute=1`;
                if (iframe.src !== newSrc) {
                  iframe.src = newSrc;
                }
              }
            } else if (iframe.src.includes('vimeo.com')) {
              // Vimeo视频
              const videoId = iframe.src.match(/video\/(\d+)/)?.[1];
              if (videoId) {
                const newSrc = `https://player.vimeo.com/video/${videoId}?muted=1&background=1`;
                if (iframe.src !== newSrc) {
                  iframe.src = newSrc;
                }
              }
            }
          } else {
            // 时间大于0时，添加循环播放参数
            if (iframe.src.includes('youtube.com')) {
              // YouTube视频
              const videoId = iframe.src.match(/embed\/([^?]+)/)?.[1];
              if (videoId && !iframe.src.includes('loop=1')) {
                const newSrc = `https://www.youtube.com/embed/${videoId}?mute=1&loop=1&playlist=${videoId}`;
                if (iframe.src !== newSrc) {
                  iframe.src = newSrc;
                }
              }
            } else if (iframe.src.includes('vimeo.com')) {
              // Vimeo视频
              const videoId = iframe.src.match(/video\/(\d+)/)?.[1];
              if (videoId && !iframe.src.includes('loop=1')) {
                const newSrc = `https://player.vimeo.com/video/${videoId}?muted=1&background=1&loop=1`;
                if (iframe.src !== newSrc) {
                  iframe.src = newSrc;
                }
              }
            }
          }
        }
      });
    }
    
    function pauseAllVideos() {
      items.forEach((item, index) => {
        if (index !== currentIndex) {
          const video = item.querySelector('video');
          const iframe = item.querySelector('iframe');
          
          if (video) {
            video.pause();
            video.currentTime = 0; // 重置到开始位置
          } else if (iframe) {
            try {
              iframe.contentWindow.postMessage('{"method":"pause"}', '*');
            } catch (e) {
              // 忽略错误
            }
          }
        }
      });
    }
    
    // 获取自动轮播时间设置
    function getAutoPlayTime() {
      return autoPlayTime !== undefined && autoPlayTime !== null ? autoPlayTime : 3;
    }
    
    // 检查当前轮播项是否为视频
    function isCurrentSlideVideo() {
      const currentItem = items[currentIndex];
      if (!currentItem) return false;
      
      // 检查是否有视频元素
      const video = currentItem.querySelector('video');
      const iframe = currentItem.querySelector('iframe');
      
      return !!(video || iframe);
    }
    
    // 开始自动轮播
    function startAutoPlay() {
      const time = getAutoPlayTime();
      
      // 如果时间为0，停止自动轮播
      if (time <= 0) {
        stopAutoPlay();
        return;
      }
      
      // 如果只有一个轮播项，不需要自动轮播
      if (items.length <= 1) {
        stopAutoPlay();
        return;
      }
      
      // 如果视频正在播放，不重复设置
      if (isVideoPlaying) {
        return;
      }
      
      // 启动前清理已有的自动播放计时器，避免并发定时器
      if (autoPlayTimer) {
        clearTimeout(autoPlayTimer);
        autoPlayTimer = null;
      }
      
      // 检查当前是否为视频
      if (isCurrentSlideVideo()) {
        const currentItem = items[currentIndex];
        const video = currentItem.querySelector('video');
        const iframe = currentItem.querySelector('iframe');
        
        if (video) {
          // 本地视频 - 等待结束事件
          isVideoPlaying = true;
          attachVideoEndHandler(video);
          // 播放视频
          playCurrentVideo();
        } else if (iframe) {
          // iframe视频（YouTube/Vimeo等）- 不受轮播时间限制
          isVideoPlaying = true;
          
          // 对于iframe视频，我们无法直接控制播放，但可以尝试发送播放命令
          try {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          } catch (e) {
            // 忽略错误
          }
          
          // 设置iframe视频的自动播放定时器
          const videoTime = Math.max(time * 3, 15); // 至少15秒，或者默认时间的3倍
          if (autoPlayTimer) { clearTimeout(autoPlayTimer); autoPlayTimer = null; }
          autoPlayTimer = setTimeout(() => {
            isVideoPlaying = false;
            // iframe视频播放完成后，延迟一段时间再切换
            setTimeout(() => {
              nextSlide();
            }, 1000);
          }, videoTime * 1000);
        }
      } else {
        // 图片轮播，使用设置的秒数
        isVideoPlaying = false;
        if (autoPlayTimer) { clearTimeout(autoPlayTimer); autoPlayTimer = null; }
        autoPlayTimer = setTimeout(() => {
          nextSlide();
        }, time * 1000);
      }
    }
    
    // 停止自动轮播
    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearTimeout(autoPlayTimer);
        autoPlayTimer = null;
      }
      isVideoPlaying = false;
      // 同时清理"恢复自动播放"的去抖计时器
      if (resumeAutoPlayTimer) {
        clearTimeout(resumeAutoPlayTimer);
        resumeAutoPlayTimer = null;
      }
    }
    
    // 更新轮播位置（仅更新位置和状态，不触发其他逻辑）
    function updateCarouselPosition() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 更新进度dot状态
      updateProgressDots();
      
      // 移动端：自动滚动tab内容到对应的tab位置
      if (window.innerWidth <= 768) {
        // 延迟执行，确保DOM更新完成
        setTimeout(() => {
          const tabContent = carousel.querySelector('.mt-tab-content');
          const activeIndicator = carousel.querySelector('.mt-tab-carousel-indicator.active');
          
          if (tabContent && activeIndicator) {
            const indicatorLeft = activeIndicator.offsetLeft;
            const tabContentWidth = tabContent.offsetWidth;
            const indicatorWidth = activeIndicator.offsetWidth;
            
            // 计算目标滚动位置，使当前激活的tab显示在屏幕中央
            const targetScrollLeft = indicatorLeft - (tabContentWidth / 2) + (indicatorWidth / 2);
            
            // 平滑滚动到目标位置 - 对tab-content进行滚动
            tabContent.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }, 50);
      }
      
      // 控制视频播放（暂停所有视频，但不自动播放）
      pauseAllVideos();
      const curItemForBind = items[currentIndex];
      if (curItemForBind) {
        const v = curItemForBind.querySelector('video');
        if (v) attachVideoEndHandler(v);
      }
    }
    
    // 更新轮播位置并播放视频（用于自动轮播）
    function updateCarouselPositionAndPlay() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 更新进度dot状态
      updateProgressDots();
      
      // 控制视频播放
      pauseAllVideos();
      const curItemForBind2 = items[currentIndex];
      if (curItemForBind2) {
        const v2 = curItemForBind2.querySelector('video');
        if (v2) attachVideoEndHandler(v2);
      }
      if (isCurrentSlideVideo()) {
        // 手动切换到视频时也要自动播放
        playCurrentVideo();
      }
    }
    
    // 强制更新轮播位置和状态
    function forceUpdateCarousel() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 控制视频播放
      pauseAllVideos();
      const curItemForBind3 = items[currentIndex];
      if (curItemForBind3) {
        const v3 = curItemForBind3.querySelector('video');
        if (v3) attachVideoEndHandler(v3);
      }
      if (isCurrentSlideVideo()) {
        // 手动切换到视频时也要自动播放
        playCurrentVideo();
      }
    }
    
    // 更新轮播图位置（不重新开始自动轮播）
    function updateCarouselWithoutAutoPlay() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 更新进度dot状态
      updateProgressDots();
      
      // 移动端：自动滚动tab内容到对应的tab位置
      if (window.innerWidth <= 768) {
        // 延迟执行，确保DOM更新完成
        setTimeout(() => {
          const tabContent = carousel.querySelector('.mt-tab-content');
          const activeIndicator = carousel.querySelector('.mt-tab-carousel-indicator.active');
          
          if (tabContent && activeIndicator) {
            const indicatorLeft = activeIndicator.offsetLeft;
            const tabContentWidth = tabContent.offsetWidth;
            const indicatorWidth = activeIndicator.offsetWidth;
            
            // 计算目标滚动位置，使当前激活的tab显示在屏幕中央
            const targetScrollLeft = indicatorLeft - (tabContentWidth / 2) + (indicatorWidth / 2);
            
            // 平滑滚动到目标位置 - 对tab-content进行滚动
            tabContent.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }, 50);
      }
      
      // 控制视频播放（但不启动自动轮播）
      pauseAllVideos();
      const curItemForBind4 = items[currentIndex];
      if (curItemForBind4) {
        const v4 = curItemForBind4.querySelector('video');
        if (v4) attachVideoEndHandler(v4);
      }
      if (isCurrentSlideVideo()) {
        // 手动切换到视频时也要自动播放
        playCurrentVideo();
      }
    }
    
    // 更新轮播图位置
    function updateCarousel() {
      content.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // 更新指示器状态
      indicators.forEach((indicator, index) => {
        if (index === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
      
      // 更新dot点状态
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      // 更新进度dot状态
      updateProgressDots();
      
      // 移动端：自动滚动tab内容到对应的tab位置
      if (window.innerWidth <= 768) {
        // 延迟执行，确保DOM更新完成
        setTimeout(() => {
          const tabContent = carousel.querySelector('.mt-tab-content');
          const activeIndicator = carousel.querySelector('.mt-tab-carousel-indicator.active');
          
          if (tabContent && activeIndicator) {
            const indicatorLeft = activeIndicator.offsetLeft;
            const tabContentWidth = tabContent.offsetWidth;
            const indicatorWidth = activeIndicator.offsetWidth;
            
            // 计算目标滚动位置，使当前激活的tab显示在屏幕中央
            const targetScrollLeft = indicatorLeft - (tabContentWidth / 2) + (indicatorWidth / 2);
            
            // 平滑滚动到目标位置 - 对tab-content进行滚动
            tabContent.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }, 50);
      }
      
      // 控制视频播放
      pauseAllVideos();
      const curItemForBind5 = items[currentIndex];
      if (curItemForBind5) {
        const v5 = curItemForBind5.querySelector('video');
        if (v5) attachVideoEndHandler(v5);
      }
      if (isCurrentSlideVideo()) {
        playCurrentVideo();
      }
    }
    
    // 用户交互时暂停自动轮播
    function pauseAutoPlayOnInteraction() {
      stopAutoPlay();
      isManualInteraction = true;
      
      // 3秒后重新开始自动轮播（去抖：清理之前的恢复定时器）
      if (resumeAutoPlayTimer) {
        clearTimeout(resumeAutoPlayTimer);
        resumeAutoPlayTimer = null;
      }
      resumeAutoPlayTimer = setTimeout(() => {
        if (!isDragging) {
          isManualInteraction = false;
          controlVideoLoop(); // 重新控制视频循环播放
          startAutoPlay();
        }
        // 一次性恢复后清空句柄
        resumeAutoPlayTimer = null;
      }, 3000);
    }
    
    // 初始化指示器点击事件（只绑定一次）
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', (e) => {
        currentIndex = index;
        updateCarouselWithoutAutoPlay();
        pauseAutoPlayOnInteraction();
      });
    });
    
    // 初始化dot点点击事件
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        currentIndex = index;
        updateCarouselWithoutAutoPlay();
        pauseAutoPlayOnInteraction();
      });
    });
    
    // 初始化进度dot点击事件
    progressDots.forEach((progressDot, index) => {
      progressDot.addEventListener('click', (e) => {
        currentIndex = index;
        updateCarouselWithoutAutoPlay();
        pauseAutoPlayOnInteraction();
      });
    });
    
    // 下一张
    function nextSlide() {
      currentIndex = (currentIndex + 1) % items.length;
      updateCarouselPosition();
      // 只有在自动轮播时间大于0时才重新开始自动轮播
      const time = getAutoPlayTime();
      if (time > 0) {
        startAutoPlay();
      }
    }
    
    // 上一张
    function prevSlide() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      updateCarouselWithoutAutoPlay();
    }
    
    // 跳转到指定索引
    function goToSlide(index) {
      currentIndex = index;
      updateCarouselWithoutAutoPlay();
    }
    
    // 鼠标事件处理
    carousel.addEventListener('mousedown', function(e) {
      if (e.target && e.target.closest('.tab-content')) return;
      isDragging = true;
      startX = e.clientX;
      currentX = startX;
      carousel.style.cursor = 'grabbing';
      content.style.transition = 'none';
      pauseAutoPlayOnInteraction();
    });
    
    carousel.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      if (e.target && e.target.closest('.tab-content')) return;
      
      currentX = e.clientX;
      const diff = currentX - startX;
      let moveX = (currentIndex * -100) + (diff / carousel.offsetWidth * 100);
      // 拖拽过程夹紧，防止越界
      if (moveX > maxTranslate) moveX = maxTranslate;
      if (moveX < minTranslate) moveX = minTranslate;
      content.style.transform = `translateX(${moveX}%)`;
    });
    
    carousel.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      if (e.target && e.target.closest('.tab-content')) return;
      
      isDragging = false;
      carousel.style.cursor = 'grab';
      content.style.transition = 'transform 0.3s ease-out';
      
      const diff = currentX - startX;
      const threshold = carousel.offsetWidth * 0.2; // 20% 阈值
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // 右划：仅在不是第一张时后退
          if (currentIndex > 0) {
            currentIndex = currentIndex - 1;
          }
          updateCarouselWithoutAutoPlay();
        } else {
          // 左划：仅在不是最后一张时前进
          if (currentIndex < items.length - 1) {
            currentIndex = currentIndex + 1;
          }
          updateCarouselWithoutAutoPlay();
        }
      } else {
        updateCarouselWithoutAutoPlay(); // 回到原位
      }
    });
    
    carousel.addEventListener('mouseleave', function() {
      if (isDragging) {
        isDragging = false;
        carousel.style.cursor = 'grab';
        content.style.transition = 'transform 0.3s ease-out';
        updateCarouselWithoutAutoPlay();
      }
    });
    
    // 按钮事件
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + items.length) % items.length;
        updateCarouselWithoutAutoPlay();
        pauseAutoPlayOnInteraction();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % items.length;
        updateCarouselWithoutAutoPlay();
        pauseAutoPlayOnInteraction();
      });
    }
    
    // 触摸事件支持（移动端）
    carousel.addEventListener('touchstart', function(e) {
      if (e.target && e.target.closest('.mt-tab-content')) return;
      isDragging = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      currentX = startX;
      content.style.transition = 'none';
      pauseAutoPlayOnInteraction();
    }, { passive: true });
    
    carousel.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      if (e.target && e.target.closest('.mt-tab-content')) return;
      
      const t = e.touches[0];
      currentX = t.clientX;
      currentY = t.clientY;
      const diffX = currentX - startX;
      const diffY = currentY - startY;
      
      // 只有在明确的横向滑动时才处理轮播和阻止纵向滚动
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 15) {
        if (e.cancelable) e.preventDefault();
        let moveX = (currentIndex * -100) + (diffX / carousel.offsetWidth * 100);
        // 拖拽过程夹紧，防止越界
        if (moveX > maxTranslate) moveX = maxTranslate;
        if (moveX < minTranslate) moveX = minTranslate;
        content.style.transform = `translateX(${moveX}%)`;
      }
      // 如果是纵向滑动，不处理轮播逻辑，让页面正常滚动
    }, { passive: false });
    
    carousel.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      if (e.target && e.target.closest('.mt-tab-content')) return;
      
      isDragging = false;
      content.style.transition = 'transform 0.3s ease-out';
      
      const diffX = currentX - startX;
      const diffY = currentY - startY;
      
      // 只有在明确的横向滑动时才处理轮播切换
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 15) {
        const threshold = carousel.offsetWidth * 0.2;
        
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            // 右划：仅在不是第一张时后退
            if (currentIndex > 0) {
              currentIndex = currentIndex - 1;
            }
            updateCarouselWithoutAutoPlay();
          } else {
            // 左划：仅在不是最后一张时前进
            if (currentIndex < items.length - 1) {
              currentIndex = currentIndex + 1;
            }
            updateCarouselWithoutAutoPlay();
          }
        } else {
          updateCarouselWithoutAutoPlay();
        }
      } else {
        // 纵向滑动，恢复到当前位置
        updateCarouselWithoutAutoPlay();
      }
    }, { passive: true });

    // touchcancel 时恢复
    carousel.addEventListener('touchcancel', function() {
      isDragging = false;
      content.style.transition = 'transform 0.3s ease-out';
      updateCarouselWithoutAutoPlay();
    }, { passive: true });
    
    // 在 .tab-content 上阻止事件冒泡到父级轮播
    const tabContent = carousel.querySelector('.mt-tab-content');
    if (tabContent) {
      ['touchstart','touchmove','touchend','mousedown','mousemove','mouseup','pointerdown','pointermove','pointerup'].forEach((evt) => {
        tabContent.addEventListener(evt, function(e){
          e.stopPropagation();
        }, { passive: true });
      });
      
      // 移动端滚动条颜色变化监听
      if (window.innerWidth <= 768) {
        tabContent.addEventListener('scroll', function() {
          const scrollLeft = tabContent.scrollLeft;
          const maxScrollLeft = tabContent.scrollWidth - tabContent.clientWidth;
          const scrollProgress = maxScrollLeft > 0 ? scrollLeft / maxScrollLeft : 0;
          
          // 根据滚动进度调整滚动条颜色
          const alpha = 0.3 + (scrollProgress * 0.7); // 从0.3到1.0的透明度
          tabContent.style.setProperty('--scrollbar-color', `rgba(254, 77, 0, ${alpha})`);
        });
      }
    }
    
    // 页面可见性变化时暂停/恢复自动轮播
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoPlay();
      } else {
        // 只有在没有手动交互时才重新开始自动轮播
        if (!isManualInteraction) {
          // 清理可能存在的恢复计时器，避免重复恢复
          if (resumeAutoPlayTimer) {
            clearTimeout(resumeAutoPlayTimer);
            resumeAutoPlayTimer = null;
          }
          controlVideoLoop(); // 重新控制视频循环播放
          startAutoPlay();
        }
      }
    });
    
    // 移动端初始化：确保第一个tab在屏幕中央
    function initMobileTabPosition() {
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          const tabContent = carousel.querySelector('.mt-tab-content');
          const firstIndicator = carousel.querySelector('.mt-tab-carousel-indicator');
          
          if (tabContent && firstIndicator) {
            const indicatorWidth = firstIndicator.offsetWidth;
            const tabContentWidth = tabContent.offsetWidth;
            
            // 计算第一个tab居中显示的位置
            const targetScrollLeft = firstIndicator.offsetLeft - (tabContentWidth / 2) + (indicatorWidth / 2);
            
            tabContent.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    }
    
    // 页面加载完成后初始化移动端tab位置
    initMobileTabPosition();
    
    // 窗口大小改变时重新计算tab位置
    window.addEventListener('resize', function() {
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          const tabContent = carousel.querySelector('.mt-tab-content');
          const activeIndicator = carousel.querySelector('.mt-tab-carousel-indicator.active');
          
          if (tabContent && activeIndicator) {
            const indicatorLeft = activeIndicator.offsetLeft;
            const tabContentWidth = tabContent.offsetWidth;
            const indicatorWidth = activeIndicator.offsetWidth;
            
            const targetScrollLeft = indicatorLeft - (tabContentWidth / 2) + (indicatorWidth / 2);
            
            tabContent.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    });
    
    // 初始化视频控制
    pauseAllVideos();
    controlVideoLoop(); // 根据设置控制视频循环播放
    if (isCurrentSlideVideo()) {
      playCurrentVideo();
    }
    
    // 初始化自动轮播
    startAutoPlay();
  }

  // 初始化所有轮播组件
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('[data-mt-tab-carousel]');
    carousels.forEach(function(carousel) {
      const carouselId = carousel.id;
      const autoPlayTimeStr = carousel.dataset.autoPlayTime;
      let autoPlayTime = 3; // 默认值
      if (autoPlayTimeStr !== undefined && autoPlayTimeStr !== null && autoPlayTimeStr !== '') {
        const parsed = parseInt(autoPlayTimeStr);
        if (!isNaN(parsed)) {
          autoPlayTime = parsed;
        }
      }
      initTabCarousel(carouselId, autoPlayTime);
    });
  });
})();

